module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopNews"
  }, [_c('div', {
    staticClass: "shopTop"
  }, [_c('div', {
    staticClass: "topLeft"
  }, [_c('div', {
    staticClass: "login",
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("亲，请登录")]), _vm._v(" "), _c('div', {
    staticClass: "register",
    on: {
      "click": _vm.goRegister
    }
  }, [_vm._v("免费注册")]), _vm._v(" "), _c('div', {
    staticClass: "home",
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('div', {
    staticClass: "topRight"
  }, [_c('div', {
    staticClass: "aboutUs",
    on: {
      "click": _vm.goAboutUs
    }
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('div', {
    staticClass: "contactUs",
    on: {
      "click": _vm.goContactUs
    }
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', {
    staticClass: "news",
    on: {
      "click": _vm.goNews
    }
  }, [_vm._v("资讯")]), _vm._v(" "), _c('div', {
    staticClass: "enter",
    on: {
      "click": _vm.goEnter
    }
  }, [_vm._v("商家入驻")])])]), _vm._v(" "), _c('div', {
    staticClass: "shopSearch"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.input3),
      callback: function($$v) {
        _vm.input3 = $$v
      },
      expression: "input3"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "shopGoods"
  }, [_c('div', {
    staticClass: "goodsLeft"
  }, [_c('div', {
    staticClass: "leftTitle"
  }, [_vm._v("热文推荐")]), _vm._v(" "), _vm._l((_vm.newsList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "leftCont",
      on: {
        "click": _vm.goQrCode
      }
    }, [_c('img', {
      attrs: {
        "src": item.src,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "newsMsg"
    }, [_c('div', {
      staticClass: "itemTitle"
    }, [_vm._v("\n            " + _vm._s(item.title) + "\n            "), _c('p', {
      staticClass: "itemPayNum"
    }, [_vm._v(_vm._s(item.payNum))])]), _vm._v(" "), _c('div', {
      staticClass: "itemMsg"
    }, [_vm._v(_vm._s(item.msg))]), _vm._v(" "), _c('div', {
      staticClass: "itemPeople"
    }, [_vm._v(_vm._s(item.people))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPayShow),
      expression: "isPayShow"
    }],
    staticClass: "pay"
  }, [_c('div', {
    staticClass: "payName"
  }, [_vm._v("微信支付")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "payClose",
    on: {
      "click": _vm.goClosePay
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/guanbi-2.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "5rem"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopLogo"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/ejklogo_01.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopLogo"
  }, [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payQrCode"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/wechatPay.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34796ccc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/page/shopPC/shopNews.vue
// module id = 3220
// module chunks = 1